import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Modal = styled(AntModal)`
    .ant-modal-title,
    .ant-modal-content {
        text-align: center;
    }

    .ant-modal-footer {
        text-align: center;
    }
`;

const ConfirmModal = ({
    open,
    message,
    onOk,
    onCancel,
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            open={open}
            width={320}
            title={t("common.notice")}
            onCancel={onCancel}
            onOk={onOk}
            okText={t("common.ok")}
            cancelText={t("common.cancel")}
        >
            {message}
        </Modal>
    );
}

export default ConfirmModal;